"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* globals module */
/**
 * @module versionRoute
 * @description Baasic Version Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Version Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
var contracts_1 = require("../../../core/contracts");
var VersionRoute = /** @class */ (function (_super) {
    tslib_1.__extends(VersionRoute, _super);
    function VersionRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
         * Versions route with route and query parameters.
         **/
        _this.getRoute = 'versions';
        return _this;
    }
    /**
     * Parses get version route.
     * @method
     * @example versionRoute.get()
     **/
    VersionRoute.prototype.get = function () {
        return _super.prototype.baseGet.call(this, this.getRoute, null, {});
    };
    var _a;
    VersionRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], VersionRoute);
    return VersionRoute;
}(common_1.BaseRoute));
exports.VersionRoute = VersionRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 
